// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-upload-area {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
}

.file-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.file-upload-label {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border: 1px solid #ced4da;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 14px;
  color: #495057;
  width: 100%;
  min-width: unset;
}

.file-upload-label:hover {
  background-color: #e9ecef;
}

.upload-icon {
  font-size: 16px;
}

.small-text {
  font-size: 12px;
}

.edit-icon-green {
  color: #198754;
  margin-left: 7px;
  cursor: pointer;
}

.loading-container {
  min-height: 200px;
}

.spinner-green {
  color: #198754;
}

.user-name-text {
  font-size: 12px;
}

.edit-icon-green {
  color: #198754;
  margin-left: 7px;
  cursor: pointer;
}

.loading-container-ehajj {
  min-height: 200px;
}

.user-transaction-table .col-date,
.main-transaction-table .col-date {
  width: 15%;
}

.user-transaction-table .col-narration,
.main-transaction-table .col-narration {
  width: 40%;
}

.user-transaction-table .col-debit,
.main-transaction-table .col-debit {
  width: 15%;
}

.user-transaction-table .col-credit,
.main-transaction-table .col-credit {
  width: 15%;
}

.user-transaction-table .col-balance,
.main-transaction-table .col-balance {
  width: 15%;
}

.monazam-account-table .monazam-narration-col {
  min-width: 320px !important;
  max-width: none !important;
}

.monazam-account-table .monazam-bank-name-col {
  min-width: 220px !important;
  max-width: none !important;
}

.monazam-account-table .monazam-debit-col {
  min-width: 55px !important;
  max-width: 75px !important;
  padding: 6px !important;
}

.monazam-account-table .monazam-credit-col {
  min-width: 55px !important;
  max-width: 75px !important;
  padding: 6px !important;
}

.monazam-account-table .monazam-balance-col {
  min-width: 65px !important;
  max-width: 85px !important;
  padding: 6px !important;
}

.bank-dropdown-custom {
  height: 70px !important;
  min-height: 70px !important;
}

.bank-dropdown-selected {
  height: 100% !important;
  min-height: 100% !important;
}

.form-select,
select.form-select {
  border: 1px solid #ced4da !important;
  border-radius: 0.25rem;
}

.form-select:focus,
select.form-select:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.form-control,
input.form-control {
  border: 1px solid #ced4da !important;
  border-radius: 0.25rem;
}

.form-control:focus,
input.form-control:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.file-name {
  font-size: 14px;
  color: #28a745;
  font-weight: 500;
}

.logo-height {
  height: 40px;
}

.label-text {
  font-size: small !important;
  font-weight: 400;
  color: #000000 !important;
}

.input-style {
  border: 1px solid #019440 !important;
  outline: none !important;
  background-color: white !important;
  box-shadow: none !important;
  font-size: x-small !important;
}

.error-text {
  font-size: 10px !important;
  font-family: 'Inter', sans-serif !important;
  font-weight: 400 !important;
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  line-height: 1.0 !important;
}

.green-btn {
  background-color: #00341a !important;
  border-color: #00341a !important;
  outline: none !important;
  box-shadow: none !important;
  color: #ffffff !important;
}

.yellow-btn {
  background-color: #ffe81a;
  color: #00341a;
  padding: 1px 10px;
  border-radius: 5px;
}

.white-arrow {
  color: white;
  font-size: small;
}

.lightgreen-txt {
  color: #019440;
  font-size: small;
}

.eye-icon {
  position: absolute;
  right: 10px;
  top: 25px;
  cursor: pointer;
  color: #00341a;
}

.login-container {
  max-width: 500px;
  width: 100%;
  padding: 1rem;
  margin: 0 auto;
  overflow-y: auto;
}

@media screen and (max-width: 576px) {
  .login-container {
    max-width: 100%;
    padding: 1rem;
    margin: 0 15px;
    height: 80vh;
  }

  .form-group {
    width: 100%;
  }

  .d-flex.justify-content-between {
    flex-direction: column !important;
  }

  .d-flex.justify-content-between .w-50 {
    width: 100% !important;
    margin: 0 0 15px 0 !important;
  }
}





.sidebar-logo-bg {
  background-color: #d6f6e3 !important;
}

.dashboard-sidebar-bg {
  background: #f3f5f3;
}

.sidebar .user-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.sidebar .lightgreen-txt {
  color: #388e3c !important;
  font-size: 12px !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  max-width: 150px !important;
  line-height: 1.2 !important;
}

.sidebar .fw-bold {
  font-weight: 600 !important;
  margin-bottom: 2px !important;
}

.sidebar .d-flex.align-items-center.justify-content-center {
  max-width: 100% !important;
  padding: 0 10px !important;
}

.sidebar .d-flex.align-items-center.justify-content-center > div {
  max-width: calc(100% - 50px) !important;
  overflow: hidden !important;
}

.plus-icon {
  font-size: x-small !important;
}

.dashboard-layout {
  display: flex;
  height: 100vh;
  width: 100%;
  overflow: hidden;
}

.main-content {
  overflow-y: auto;
  overflow-x: hidden;
}

.main-content::-webkit-scrollbar {
  width: 8px;
}

.main-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.main-content::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.main-content::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.user-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.maincontent-container {
  background-color: #fafafa;
  height: 90vh !important;
  padding-left: 30px !important;
  margin-left: 0 !important;
}

@media (min-width: 768px) {
  .maincontent-container {
    margin-left: 210px !important;
    width: calc(100% - 210px) !important;
  }
}



.nav-item {
  flex: 0 1 auto;
}

.tab-link {
  white-space: nowrap;
  padding: 4px 10px;
  color: #333;
  text-decoration: none;
  border-radius: 4px;
  transition: all 0.3s ease;
  font-size: 11px;
  box-sizing: border-box;
}

/* Default: hide scrollbar on desktop */
.ResponsiveTabs::-webkit-scrollbar {
  display: none;
}

.ResponsiveTabs {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  /* Gap fallback for older browsers */
  margin: 0 -1px;
  gap: 2px;
  max-width: 100%;
  overflow: hidden;
}

.ResponsiveTabs .nav-item {
  /* Gap fallback - margin instead of gap for older browsers */
  margin: 0 1px;
  flex: 0 0 auto;
  white-space: nowrap;
}

/* Large screens - default styling */
@media (min-width: 1350px) {
  .ResponsiveTabs {
    flex-wrap: nowrap;
  }
  
  .tab-link {
    padding: 4px 10px;
    font-size: 11px;
  }
}

/* Medium screens - reduce padding and allow wrap */
@media (min-width: 768px) and (max-width: 1349px) {
  .ResponsiveTabs {
    flex-wrap: wrap;
    max-width: 100%;
  }
  
  .tab-link {
    padding: 4px 8px;
    font-size: 10px;
  }
}

/* Mobile devices - single line with scrollbar */
@media screen and (max-width: 767px) {
  .ResponsiveTabs {
    flex-wrap: nowrap !important;
    max-width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    /* Firefox scrollbar */
    scrollbar-width: thin;
    scrollbar-color: #888 #f1f1f1;
  }

  /* Webkit browsers (Chrome, Safari, Edge) scrollbar */
  .ResponsiveTabs::-webkit-scrollbar {
    height: 6px;
    display: block;
    -webkit-appearance: none;
  }

  .ResponsiveTabs::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  .ResponsiveTabs::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }

  .ResponsiveTabs::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  /* Firefox scrollbar fallback */
  .ResponsiveTabs {
    scrollbar-width: thin;
    scrollbar-color: #888 #f1f1f1;
  }

  .tab-link {
    padding: 8px;
    font-size: 8px;
    white-space: nowrap;
    box-sizing: border-box;
  }
}


.marginRight {
  margin-right: 20px !important;
}

@media (min-width: 768px) {
  .main-content-table {
    margin-left: 240px !important;
    width: calc(100% - 250px) !important;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100vh;
  }
  
  .main-content-table::-webkit-scrollbar {
    width: 8px;
  }
  
  .main-content-table::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  .main-content-table::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }
  
  .main-content-table::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}

.content-container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.table-wrapper {
  margin-bottom: 10px;
  min-height: 400px;
  border-radius: 6px;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  overflow-x: auto !important;
  overflow-y: visible !important;
  width: 100% !important;
}

.table-container {
  overflow-y: auto;
  overflow-x: auto;
  position: relative;
  max-height: calc(100vh - 300px);
}

.table-container::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
}

.bgColor {
  background-color: #fafafa;
}

.dropdown-toggle::after {
  margin-left: 17px !important;
}

.marginLeft {
  margin-left: 14px;
}

@media (max-width: 799px) {
  .scroll {
    width: 500px;
  }
}

@media (max-width: 766px) {
  .scroll {
    width: 700px;
  }
}

@media (max-width: 575px) {
  .scroll {
    width: 500px;
  }
}

@media (max-width: 500px) {
  .scroll {
    width: 400px;
  }
}

@media (max-width: 420px) {
  .scroll {
    width: 320px;
  }
}

@media (max-width: 420px) {
  .scrollMerchent {
    width: 380px;
  }
}

@media (max-width: 767px) {
  .main-content-table {
    margin-left: 0;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100vh;
  }
  
  .main-content-table::-webkit-scrollbar {
    width: 8px;
  }
  
  .main-content-table::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  .main-content-table::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }
  
  .main-content-table::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}



.text-sm {
  font-size: 14px;
}

.negetiveMargin {
  margin-right: 20px;
}

.tab-link {
  color: #000000 !important;
  font-size: 16px !important;
  font-weight: 500;
}

.tab-link.active {
  color: #019440 !important;
}

.pagination .page-link {
  color: #000000;
  font-size: 8px;
}

.pagination .page-link:hover {
  color: #019440;
  background-color: #ffffff !important;
  border-color: #27272a !important;
}

.pagination .page-link:focus {
  outline: none;
}

.pagination .page-item.active .page-link {
  background-color: #019440;
  border-color: #019440 !important;
}

.transferbtn:disabled {
  border: none !important;
  outline: none !important;
}

.filter-btn {
  min-width: 80px;
  height: 30px;
  font-weight: 600 !important;
  box-shadow: -1px 3px 0px rgba(0, 1, 1, 0.2) !important;
}

.btn-outline-secondary {
  color: #000 !important;
  border-color: #ffffff !important;
  background-color: #ffffff !important;
  font-size: x-small !important;
}

.approved-btn {
  color: #ffffff;
  border-color: #019440 !important;
  background-color: #ffffff !important;
  text-transform: capitalize;
  font-size: 14px !important;
  min-width: 80px !important;
}

.rejectbtn {
  color: #ffffff !important;
  font-size: 14px !important;
  border-color: red !important;
  background-color: red !important;
  width: 80px !important;
}

.btn-outline-secondary:hover {
  color: #019440 !important;
  border-color: #019440 !important;
  background-color: #ffffff !important;
}

.edit-icon {
  width: 20px !important;
}

.btn-outline-secondary:focus {
  outline: none;
}

.tableheader-txt {
  font-size: 11px !important;
  color: #a1a1aa !important;
  font-weight: 500 !important;
  padding: 8px 12px !important;
}

.tableheader-txt-merchent {
  font-size: 12px !important;
  color: #a1a1aa !important;
  font-weight: 500 !important;
}

.tabledata-txt {
  font-size: 11px !important;
  color: #27272a !important;
  font-weight: 400 !important;
  padding: 12px !important;
  vertical-align: middle !important;
}

.table-responsive {
  min-height: 400px !important;
  overflow-x: auto !important;
  overflow-y: visible !important;
  width: 100% !important;
  margin-left: 0 !important;
  padding-left: 0 !important;
  position: relative !important;
}

.table-responsive::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.table-responsive::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.table-responsive::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.table-responsive::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.table-responsive table {
  min-width: 1000px !important;
  width: 100% !important;
  table-layout: auto !important;
}

.table-responsive table th:nth-child(4),
.table-responsive table td:nth-child(4) {
  width: auto !important;
  min-width: 50px !important;
  max-width: 70px !important;
  padding-left: 8px !important;
  padding-right: 8px !important;
}

.table-responsive table th:nth-child(5),
.table-responsive table td:nth-child(5) {
  width: auto !important;
  min-width: 60px !important;
  max-width: 80px !important;
  padding-left: 8px !important;
  padding-right: 8px !important;
}

.table-responsive table th:nth-child(6),
.table-responsive table td:nth-child(6) {
  width: auto !important;
  min-width: 60px !important;
  max-width: 80px !important;
  padding-left: 8px !important;
  padding-right: 8px !important;
}

.table {
  margin-bottom: 0 !important;
}

.table tbody tr {
  min-height: 50px !important;
}

@media (min-width: 1280px) {
  .tableheader-txt {
    font-size: 12px !important;
    color: #a1a1aa !important;
    font-weight: 500 !important;
    padding: 8px 12px !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }
  
  .tabledata-txt {
    font-size: 12px !important;
    color: #27272a !important;
    font-weight: 400 !important;
    padding: 12px !important;
    vertical-align: middle !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }
  
  .table th {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }
  
  .table th:nth-child(2) {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }
  
  .table th:nth-child(4) {
    white-space: normal !important;
    word-wrap: break-word !important;
    overflow: visible !important;
    text-overflow: initial !important;
  }
  
  .navbar-nav {
    flex-wrap: nowrap !important;
  }
  
  .navbar-nav .nav-link {
    white-space: nowrap !important;
  }
  
  .ResponsiveTabs {
    flex-wrap: nowrap !important;
    white-space: nowrap !important;
    max-width: 100% !important;
    overflow: hidden !important;
  }

  .ResponsiveTabs .nav-item {
    white-space: nowrap !important;
  }

  .ResponsiveTabs .nav-link {
    white-space: nowrap !important;
    padding: 6px 10px !important;
    font-size: 12px !important;
    box-sizing: border-box !important;
  }
  
  .table {
    table-layout: fixed !important;
    width: 100% !important;
  }
  
  .table th:nth-child(1) { width: 120px !important; }
  .table th:nth-child(2) { width: 140px !important; }
  .table th:nth-child(3) { width: 100px !important; }
  .table th:nth-child(4) { width: 200px !important; }
  .table th:nth-child(5) { width: 150px !important; }
  .table th:nth-child(6) { width: 120px !important; }
  .table th:nth-child(7) { width: 80px !important; }
  .table th:nth-child(8) { width: 100px !important; }
  .table th:nth-child(9) { width: 120px !important; }
  
  .table td {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    max-width: 0 !important;
  }
  
  .table td:nth-child(2) {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    max-width: 140px !important;
    width: 140px !important;
  }
  
  .table td:nth-child(4) {
    white-space: normal !important;
    word-wrap: break-word !important;
    overflow: visible !important;
    text-overflow: initial !important;
    max-width: 200px !important;
    width: 200px !important;
  }
  
  .table td:nth-child(1) { width: 120px !important; max-width: 120px !important; }
  .table td:nth-child(3) { width: 100px !important; max-width: 100px !important; }
  .table td:nth-child(5) { width: 150px !important; max-width: 150px !important; }
  .table td:nth-child(6) { width: 120px !important; max-width: 120px !important; }
  .table td:nth-child(7) { width: 80px !important; max-width: 80px !important; }
  .table td:nth-child(8) { width: 100px !important; max-width: 100px !important; }
  .table td:nth-child(9) { width: 120px !important; max-width: 120px !important; }
}

.fixed {
  position: fixed;
}

.inset-0 {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.z-50 {
  z-index: 50;
}

.bg-black {
  background-color: rgba(0, 0, 0, 0.5);
}

.flex {
  display: flex;
}

.items-center {
  align-items: center;
}

.justify-center {
  justify-content: center;
}

.modal-blur-bg {
  background-color: rgba(0, 0, 0, 0.3);
}

.modal-heading-txt {
  font-size: medium !important;
  font-weight: 600 !important;
  color: #000000 !important;
}

.modal-label-txt {
  font-size: small !important;
}

.modal-input-txt {
  font-size: x-small !important;
  outline: none !important;
  box-shadow: none !important;
  border-color: #a1a1aa !important;
  border: #ffffff;
}

.modal-input-txt:hover {
  border-color: #019440 !important;
}

.modal-btn-bg {
  background-color: #019440 !important;
  color: #ffffff !important;
}

.modal-header {
  border-bottom: none !important;
}

.modal-footer {
  border-top: none !important;
}

.notification-modal {
  margin: 0 !important;
}

.notification-modalposition {
  display: block !important;
  position: fixed !important;
  top: 8% !important;
  left: 75% !important;
  z-index: 1050 !important;
}

.notification-modal-height {
  height: 300px !important;
  width: 300px !important;
  border: 1px solid #000000 !important;
}

.separator {
  border-left: 2px solid #019440;
  height: 30px;
  margin: 0 10px;
}

.balance-box {
  border: 1px solid #019440;
  border-radius: 4px;
  min-width: 180px;
  justify-content: center;
  align-items: center;
  min-height: 70px;
  height: 70px;
  display: flex;
}

.bank-dropdown-wrapper {
  min-height: 100%;
}

.bank-select {
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 2;
  cursor: pointer;
}

.bank-select-display {
  min-height: 100%;
  padding: 0;
  pointer-events: none;
  z-index: 1;
}

.balance-txt {
  font-size: 12px;
  font-weight: bold;
  color: #9fa6b2;
}

.bank-select-option {
  display: flex;
  flex-direction: column;
  font-size: 12px;
  font-weight: bold;
  color: #9fa6b2;
}

.amount-txt {
  font-size: 16px;
  color: #019440 !important;
}

.hgo-text {
  margin-right: auto;
  font-size: 14px !important;
  font-weight: 600 !important;
}

.textSizeIcon {
  font-size: 22px;
}

.dropdown-section {
  margin-top: 1rem;
}

.plus-minus-btn {
  border: none !important;
  background-color: transparent;
}

.sidebar {
  position: fixed;
  top: 0;
  left: -250px;
  width: 240px !important;
  height: 100%;
  background: #f3f5f3;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  transition: left 0.3s ease;
  z-index: 1000;
  flex-shrink: 0;
}

.sidebar.open {
  left: 0;
}

.main-content.blurred {
  filter: blur(3px);
  pointer-events: none;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: none;
}

.sidebar.open~.overlay {
  display: block;
}

.plus-icon {
  margin-left: auto;
}

.sidebar-logo-bg {
  padding: 10px;
}

.close-btn {
  background: transparent;
  border: none;
  padding-bottom: 18px !important;
  position: absolute;
  right: -7px;
  top: 15px;
}

.close-btn:hover {
  cursor: pointer;
}

.btn-close-notification {
  outline: none !important;
  box-shadow: none !important;
}

@media (min-width: 768px) {
  .close-btn {
    display: none;
  }

  .sidebar {
    position: fixed;
    left: 0;
    width: 210px;
    height: 100%;
    background: #f3f5f3;
    z-index: 1;
    box-shadow: none;
  }
}

.dropdown-toggle::after {
  border-top: 0.8em solid !important;
  border-right: 0.4em solid transparent !important;
  border-left: 0.4em solid transparent !important;
  vertical-align: middle !important;
}

.main-content {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.main-content1 {
  flex-grow: 1 !important;
  width: 158% !important;
  margin-left: 20px;
  padding: 0;
}

.main-content-incoming {
  flex-grow: 1 !important;
  width: 138% !important;
  margin-left: 20px;
  padding: 0;
}

.maincontent-container1 {
  background-color: #fafafa;
  height: 94.5vh !important;
  flex-grow: 1 !important;
}

.page-link:focus {
  box-shadow: none !important;
  outline: none !important;
}

@media (max-width: 576px) {
  .bell-icon {
    margin-left: 0px !important;
  }

  .main-content {
    margin-left: 0px !important;
  }

  .main-content1 {
    margin-left: 0px;
    width: 100% !important;
  }

  .notification-modalposition {
    display: block !important;
    position: fixed !important;
    top: 25% !important;
    left: 15% !important;
    z-index: 1050 !important;
  }
}

.transferbtn {
  border-color: none !important;
  box-shadow: none !important;
  transition: all 0.3s ease;
  font-size: 11px !important;
  padding: 4px 12px !important;
}

.transferbtn:hover {
  border-color: #019440 !important;
  color: #019440 !important;
}

.transferbtn.active {
  background-color: #019440;
}

.btn-compact {
  padding: 0.1rem 0.1rem !important;
  color: #ffffff;
  border-color: #019440 !important;
  background-color: #ffffff !important;
  font-size: xx-small !important;
  width: 45px !important;
  margin-bottom: 3px;
}

.btn-compactreject {
  padding: 0.1rem 0.1rem !important;
  color: #ffffff !important;
  border-color: red !important;
  background-color: red !important;
  font-size: xx-small !important;
  width: 45px !important;
  margin-bottom: 3px;
}

.add-button {
  background-color: #cffce1;
  width: 60px;
  height: 40px;
  border-radius: 5px;
  padding: 10px;
  border: none !important;
}

.greenplusbtn {
  color: #019440 !important;
  font-size: 20px !important;
}

.bgWhite {
  background-color: #fff;
  padding: 10px;
  margin-top: -23px;
  margin-left: -23px;
  padding-left: 40px;
}

.container {
  margin: 20px auto;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-height: 100vh;
  overflow-y: auto;
  overflow-x: none;
}

.myContainer {
  overflow-x: hidden;
  padding: 10px;
}

.rola {
  width: 100%;
  display: flex;
  justify-content: end;
}

h2 {
  color: #333;
}

.form {
  display: flex;
  flex-direction: column;
}

.row {
  display: flex;
  margin-bottom: 15px;
}

.heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 10px;
  padding-right: 10px;
  margin-top: 20px;
}

.column {
  flex: 0 0 33.33%;
  display: flex;
  flex-direction: column;
}

select {
  font-size: 14px !important;
  width: 30px;
}

.margin {
  margin-right: 100px;
}

label {
  margin-bottom: 5px;
  color: #555;
}

input,
select {
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 10px;
  width: 100%;
}

.date input {
  text-align: center;
  background-color: #e9ecef;
  border: none;
  width: 100px;
  font-size: 12px;
}

.submit-btn {
  background-color: #019440;
  color: white;
  padding: 10px;
  font-size: 16px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 10px;
}

.add-btn {
  color: #28a745;
  background: #FAFAFA;
  padding: 10px;
  font-size: 16px;
  border: none;
  cursor: pointer;
  margin-top: 10px;
  font-weight: bold;
}

.add-btn {
  width: 100px;
  align-self: flex-start;
}

.submit-btn {
  width: 30%;
  align-self: center;
}

.submit-btn:hover {
  background-color: #218838;
}

.textSize {
  font-size: 116px !important;
}

@media (max-width: 768px) {
  .row {
    flex-direction: column;
  }
}

@media (max-width: 768px) {
  .rola {
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .myContainer {
    height: 60vh;
    overflow-y: scroll;
  }
}

@media (max-width: 760px) {
  .myContainer {
    height: 55vh;
    overflow-y: scroll;
  }
}


.conversion {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.btn-approved {
  background-color: #28a745 !important;
  color: white !important;
  border: none !important;
  border-radius: 4px !important;
  padding: 4px 12px !important;
  font-size: 12px !important;
}

.btn-reject {
  background-color: #dc3545 !important;
  color: white !important;
  border: none !important;
  border-radius: 4px !important;
  padding: 4px 12px !important;
  font-size: 12px !important;
}

.btn-pending {
  background-color: #ffc107 !important;
  color: white !important;
  border: none !important;
  border-radius: 4px !important;
  padding: 4px 12px !important;
  font-size: 12px !important;
}

.loading-container {
  min-height: 200px;
}

.spinner-green {
  color: #198754;
}

.user-name-text {
  font-size: 12px;
}

.edit-icon-green {
  color: #198754;
  margin-left: 7px;
  cursor: pointer;
}

.loading-container-ehajj {
  min-height: 200px;
}

.user-transaction-table .col-date,
.main-transaction-table .col-date {
  width: 15%;
}

.user-transaction-table .col-narration,
.main-transaction-table .col-narration {
  width: 40%;
}

.user-transaction-table .col-debit,
.main-transaction-table .col-debit {
  width: 15%;
}

.user-transaction-table .col-credit,
.main-transaction-table .col-credit {
  width: 15%;
}

.user-transaction-table .col-balance,
.main-transaction-table .col-balance {
  width: 15%;
}

.monazam-account-table .monazam-narration-col {
  min-width: 320px !important;
  max-width: none !important;
}

.monazam-account-table .monazam-bank-name-col {
  min-width: 220px !important;
  max-width: none !important;
}

.monazam-account-table .monazam-debit-col {
  min-width: 55px !important;
  max-width: 75px !important;
  padding: 6px !important;
}

.monazam-account-table .monazam-credit-col {
  min-width: 55px !important;
  max-width: 75px !important;
  padding: 6px !important;
}

.monazam-account-table .monazam-balance-col {
  min-width: 65px !important;
  max-width: 85px !important;
  padding: 6px !important;
}

.bank-dropdown-custom {
  height: 70px !important;
  min-height: 70px !important;
}

.bank-dropdown-selected {
  height: 100% !important;
  min-height: 100% !important;
}

.filter-button {
  color: black;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.15);
  font-size: 14px;
}

.conversion input {
  width: 45%;
  padding: 5px;
  margin: 0 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

button {
  font-size: 12px;
  padding: 10px 15px;
  margin: 5px;
  border: none;
  background: #007bff;
  color: #fff;
  border-radius: 5px;
  cursor: pointer;
}

button:disabled {
  background: #ccc;
}

.download-btn {
  background-color: transparent;
  border: none;
  padding: 5px;
  cursor: pointer;
}

.download-icon {
  color: #333;
  font-size: 16px;
}

.small-text {
  font-size: 12px;
}

.edit-icon-green {
  color: #198754;
  margin-left: 7px;
  cursor: pointer;
}

.loading-container {
  min-height: 200px;
}

.spinner-green {
  color: #198754;
}

.user-name-text {
  font-size: 12px;
}

.edit-icon-green {
  color: #198754;
  margin-left: 7px;
  cursor: pointer;
}

.loading-container-ehajj {
  min-height: 200px;
}

.user-transaction-table .col-date,
.main-transaction-table .col-date {
  width: 15%;
}

.user-transaction-table .col-narration,
.main-transaction-table .col-narration {
  width: 40%;
}

.user-transaction-table .col-debit,
.main-transaction-table .col-debit {
  width: 15%;
}

.user-transaction-table .col-credit,
.main-transaction-table .col-credit {
  width: 15%;
}

.user-transaction-table .col-balance,
.main-transaction-table .col-balance {
  width: 15%;
}

.monazam-account-table .monazam-narration-col {
  min-width: 320px !important;
  max-width: none !important;
}

.monazam-account-table .monazam-bank-name-col {
  min-width: 220px !important;
  max-width: none !important;
}

.monazam-account-table .monazam-debit-col {
  min-width: 55px !important;
  max-width: 75px !important;
  padding: 6px !important;
}

.monazam-account-table .monazam-credit-col {
  min-width: 55px !important;
  max-width: 75px !important;
  padding: 6px !important;
}

.monazam-account-table .monazam-balance-col {
  min-width: 65px !important;
  max-width: 85px !important;
  padding: 6px !important;
}

.bank-dropdown-custom {
  height: 70px !important;
  min-height: 70px !important;
}

.bank-dropdown-selected {
  height: 100% !important;
  min-height: 100% !important;
}

.file-upload-area {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
}

.file-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.file-upload-label {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border: 1px solid #ced4da;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 14px;
  color: #495057;
  width: 100%;
  min-width: unset;
}

.file-upload-label:hover {
  background-color: #e9ecef;
}

.upload-icon {
  font-size: 16px;
}

.small-text {
  font-size: 12px;
}

.edit-icon-green {
  color: #198754;
  margin-left: 7px;
  cursor: pointer;
}

.loading-container {
  min-height: 200px;
}

.spinner-green {
  color: #198754;
}

.user-name-text {
  font-size: 12px;
}

.edit-icon-green {
  color: #198754;
  margin-left: 7px;
  cursor: pointer;
}

.loading-container-ehajj {
  min-height: 200px;
}

.user-transaction-table .col-date,
.main-transaction-table .col-date {
  width: 15%;
}

.user-transaction-table .col-narration,
.main-transaction-table .col-narration {
  width: 40%;
}

.user-transaction-table .col-debit,
.main-transaction-table .col-debit {
  width: 15%;
}

.user-transaction-table .col-credit,
.main-transaction-table .col-credit {
  width: 15%;
}

.user-transaction-table .col-balance,
.main-transaction-table .col-balance {
  width: 15%;
}

.monazam-account-table .monazam-narration-col {
  min-width: 320px !important;
  max-width: none !important;
}

.monazam-account-table .monazam-bank-name-col {
  min-width: 220px !important;
  max-width: none !important;
}

.monazam-account-table .monazam-debit-col {
  min-width: 55px !important;
  max-width: 75px !important;
  padding: 6px !important;
}

.monazam-account-table .monazam-credit-col {
  min-width: 55px !important;
  max-width: 75px !important;
  padding: 6px !important;
}

.monazam-account-table .monazam-balance-col {
  min-width: 65px !important;
  max-width: 85px !important;
  padding: 6px !important;
}

.bank-dropdown-custom {
  height: 70px !important;
  min-height: 70px !important;
}

.bank-dropdown-selected {
  height: 100% !important;
  min-height: 100% !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;EAEE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;;EAEE,qBAAqB;EACrB,UAAU;EACV,kDAAkD;AACpD;;AAEA;;EAEE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;;EAEE,qBAAqB;EACrB,UAAU;EACV,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,kCAAkC;EAClC,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,2CAA2C;EAC3C,2BAA2B;EAC3B,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,wBAAwB;EACxB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;IACf,aAAa;IACb,cAAc;IACd,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,sBAAsB;IACtB,6BAA6B;EAC/B;AACF;;;;;;AAMA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,gCAAgC;EAChC,oCAAoC;EACpC,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE;IACE,6BAA6B;IAC7B,oCAAoC;EACtC;AACF;;;;AAIA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EAGrB,kBAAkB;EAIlB,yBAAyB;EACzB,eAAe;EAGf,sBAAsB;AACxB;;AAEA,uCAAuC;AACvC;EACE,aAAa;AACf;;AAEA;EAGE,aAAa;EAGb,eAAe;EAGf,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4DAA4D;EAC5D,aAAa;EAGb,cAAc;EACd,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE;IAGE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,mDAAmD;AACnD;EACE;IAGE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA,gDAAgD;AAChD;EACE;IAGE,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,sBAAsB;IACtB,qBAAqB;IACrB,6BAA6B;EAC/B;;EAEA,qDAAqD;EACrD;IACE,WAAW;IACX,cAAc;IACd,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;IAEnB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAEhB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,+BAA+B;EAC/B;IACE,qBAAqB;IACrB,6BAA6B;EAC/B;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,mBAAmB;IAGnB,sBAAsB;EACxB;AACF;;;AAGA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,6BAA6B;IAC7B,oCAAoC;IACpC,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,uCAAuC;EACvC,2BAA2B;EAC3B,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;AACF;;;;AAIA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,2BAA2B;EAC3B,sDAAsD;AACxD;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,oCAAoC;EACpC,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;EAC5B,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,8BAA8B;EAC9B,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,2BAA2B;IAC3B,4BAA4B;IAC5B,8BAA8B;IAC9B,2BAA2B;IAC3B,kCAAkC;EACpC;;EAEA;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,2BAA2B;IAC3B,wBAAwB;IACxB,iCAAiC;IACjC,8BAA8B;IAC9B,2BAA2B;IAC3B,kCAAkC;EACpC;;EAEA;IACE,8BAA8B;IAC9B,2BAA2B;IAC3B,kCAAkC;EACpC;;EAEA;IACE,8BAA8B;IAC9B,2BAA2B;IAC3B,kCAAkC;EACpC;;EAEA;IACE,8BAA8B;IAC9B,gCAAgC;IAChC,4BAA4B;IAC5B,iCAAiC;EACnC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IAGE,4BAA4B;IAC5B,8BAA8B;IAC9B,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;IAC9B,4BAA4B;IAC5B,0BAA0B;IAG1B,iCAAiC;EACnC;;EAEA;IACE,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA,yBAAyB,uBAAuB,EAAE;EAClD,yBAAyB,uBAAuB,EAAE;EAClD,yBAAyB,uBAAuB,EAAE;EAClD,yBAAyB,uBAAuB,EAAE;EAClD,yBAAyB,uBAAuB,EAAE;EAClD,yBAAyB,uBAAuB,EAAE;EAClD,yBAAyB,sBAAsB,EAAE;EACjD,yBAAyB,uBAAuB,EAAE;EAClD,yBAAyB,uBAAuB,EAAE;;EAElD;IACE,8BAA8B;IAC9B,2BAA2B;IAC3B,kCAAkC;IAClC,uBAAuB;EACzB;;EAEA;IACE,8BAA8B;IAC9B,2BAA2B;IAC3B,kCAAkC;IAClC,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,8BAA8B;IAC9B,gCAAgC;IAChC,4BAA4B;IAC5B,iCAAiC;IACjC,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA,yBAAyB,uBAAuB,EAAE,2BAA2B,EAAE;EAC/E,yBAAyB,uBAAuB,EAAE,2BAA2B,EAAE;EAC/E,yBAAyB,uBAAuB,EAAE,2BAA2B,EAAE;EAC/E,yBAAyB,uBAAuB,EAAE,2BAA2B,EAAE;EAC/E,yBAAyB,sBAAsB,EAAE,0BAA0B,EAAE;EAC7E,yBAAyB,uBAAuB,EAAE,2BAA2B,EAAE;EAC/E,yBAAyB,uBAAuB,EAAE,2BAA2B,EAAE;AACjF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,2BAA2B;EAC3B,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,MAAM;EACN,OAAO;EACP,UAAU;EACV,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,0BAA0B;EAC1B,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,OAAO;IACP,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,gBAAgB;EAClB;AACF;;AAEA;EACE,kCAAkC;EAClC,gDAAgD;EAChD,+CAA+C;EAC/C,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,mBAAmB;IACnB,oBAAoB;IACpB,wBAAwB;EAC1B;AACF;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,gCAAgC;EAChC,oCAAoC;EACpC,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,4BAA4B;EAC5B,gCAAgC;EAChC,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;EACpB;AACF;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B","sourcesContent":[".file-upload-area {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 1rem;\n}\n\n.file-input {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.file-upload-label {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1rem;\n  background-color: #f8f9fa;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  font-size: 14px;\n  color: #495057;\n  width: 100%;\n  min-width: unset;\n}\n\n.file-upload-label:hover {\n  background-color: #e9ecef;\n}\n\n.upload-icon {\n  font-size: 16px;\n}\n\n.small-text {\n  font-size: 12px;\n}\n\n.edit-icon-green {\n  color: #198754;\n  margin-left: 7px;\n  cursor: pointer;\n}\n\n.loading-container {\n  min-height: 200px;\n}\n\n.spinner-green {\n  color: #198754;\n}\n\n.user-name-text {\n  font-size: 12px;\n}\n\n.edit-icon-green {\n  color: #198754;\n  margin-left: 7px;\n  cursor: pointer;\n}\n\n.loading-container-ehajj {\n  min-height: 200px;\n}\n\n.user-transaction-table .col-date,\n.main-transaction-table .col-date {\n  width: 15%;\n}\n\n.user-transaction-table .col-narration,\n.main-transaction-table .col-narration {\n  width: 40%;\n}\n\n.user-transaction-table .col-debit,\n.main-transaction-table .col-debit {\n  width: 15%;\n}\n\n.user-transaction-table .col-credit,\n.main-transaction-table .col-credit {\n  width: 15%;\n}\n\n.user-transaction-table .col-balance,\n.main-transaction-table .col-balance {\n  width: 15%;\n}\n\n.monazam-account-table .monazam-narration-col {\n  min-width: 320px !important;\n  max-width: none !important;\n}\n\n.monazam-account-table .monazam-bank-name-col {\n  min-width: 220px !important;\n  max-width: none !important;\n}\n\n.monazam-account-table .monazam-debit-col {\n  min-width: 55px !important;\n  max-width: 75px !important;\n  padding: 6px !important;\n}\n\n.monazam-account-table .monazam-credit-col {\n  min-width: 55px !important;\n  max-width: 75px !important;\n  padding: 6px !important;\n}\n\n.monazam-account-table .monazam-balance-col {\n  min-width: 65px !important;\n  max-width: 85px !important;\n  padding: 6px !important;\n}\n\n.bank-dropdown-custom {\n  height: 70px !important;\n  min-height: 70px !important;\n}\n\n.bank-dropdown-selected {\n  height: 100% !important;\n  min-height: 100% !important;\n}\n\n.form-select,\nselect.form-select {\n  border: 1px solid #ced4da !important;\n  border-radius: 0.25rem;\n}\n\n.form-select:focus,\nselect.form-select:focus {\n  border-color: #86b7fe;\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n\n.form-control,\ninput.form-control {\n  border: 1px solid #ced4da !important;\n  border-radius: 0.25rem;\n}\n\n.form-control:focus,\ninput.form-control:focus {\n  border-color: #86b7fe;\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n\n.file-name {\n  font-size: 14px;\n  color: #28a745;\n  font-weight: 500;\n}\n\n.logo-height {\n  height: 40px;\n}\n\n.label-text {\n  font-size: small !important;\n  font-weight: 400;\n  color: #000000 !important;\n}\n\n.input-style {\n  border: 1px solid #019440 !important;\n  outline: none !important;\n  background-color: white !important;\n  box-shadow: none !important;\n  font-size: x-small !important;\n}\n\n.error-text {\n  font-size: 10px !important;\n  font-family: 'Inter', sans-serif !important;\n  font-weight: 400 !important;\n  margin-top: 0px !important;\n  margin-bottom: 0px !important;\n  line-height: 1.0 !important;\n}\n\n.green-btn {\n  background-color: #00341a !important;\n  border-color: #00341a !important;\n  outline: none !important;\n  box-shadow: none !important;\n  color: #ffffff !important;\n}\n\n.yellow-btn {\n  background-color: #ffe81a;\n  color: #00341a;\n  padding: 1px 10px;\n  border-radius: 5px;\n}\n\n.white-arrow {\n  color: white;\n  font-size: small;\n}\n\n.lightgreen-txt {\n  color: #019440;\n  font-size: small;\n}\n\n.eye-icon {\n  position: absolute;\n  right: 10px;\n  top: 25px;\n  cursor: pointer;\n  color: #00341a;\n}\n\n.login-container {\n  max-width: 500px;\n  width: 100%;\n  padding: 1rem;\n  margin: 0 auto;\n  overflow-y: auto;\n}\n\n@media screen and (max-width: 576px) {\n  .login-container {\n    max-width: 100%;\n    padding: 1rem;\n    margin: 0 15px;\n    height: 80vh;\n  }\n\n  .form-group {\n    width: 100%;\n  }\n\n  .d-flex.justify-content-between {\n    flex-direction: column !important;\n  }\n\n  .d-flex.justify-content-between .w-50 {\n    width: 100% !important;\n    margin: 0 0 15px 0 !important;\n  }\n}\n\n\n\n\n\n.sidebar-logo-bg {\n  background-color: #d6f6e3 !important;\n}\n\n.dashboard-sidebar-bg {\n  background: #f3f5f3;\n}\n\n.sidebar .user-circle {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.sidebar .lightgreen-txt {\n  color: #388e3c !important;\n  font-size: 12px !important;\n  word-wrap: break-word !important;\n  overflow-wrap: break-word !important;\n  max-width: 150px !important;\n  line-height: 1.2 !important;\n}\n\n.sidebar .fw-bold {\n  font-weight: 600 !important;\n  margin-bottom: 2px !important;\n}\n\n.sidebar .d-flex.align-items-center.justify-content-center {\n  max-width: 100% !important;\n  padding: 0 10px !important;\n}\n\n.sidebar .d-flex.align-items-center.justify-content-center > div {\n  max-width: calc(100% - 50px) !important;\n  overflow: hidden !important;\n}\n\n.plus-icon {\n  font-size: x-small !important;\n}\n\n.dashboard-layout {\n  display: flex;\n  height: 100vh;\n  width: 100%;\n  overflow: hidden;\n}\n\n.main-content {\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.main-content::-webkit-scrollbar {\n  width: 8px;\n}\n\n.main-content::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.main-content::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 4px;\n}\n\n.main-content::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.user-circle {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.maincontent-container {\n  background-color: #fafafa;\n  height: 90vh !important;\n  padding-left: 30px !important;\n  margin-left: 0 !important;\n}\n\n@media (min-width: 768px) {\n  .maincontent-container {\n    margin-left: 210px !important;\n    width: calc(100% - 210px) !important;\n  }\n}\n\n\n\n.nav-item {\n  flex: 0 1 auto;\n}\n\n.tab-link {\n  white-space: nowrap;\n  padding: 4px 10px;\n  color: #333;\n  text-decoration: none;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n  -webkit-transition: all 0.3s ease;\n  -moz-transition: all 0.3s ease;\n  -o-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n  font-size: 11px;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n/* Default: hide scrollbar on desktop */\n.ResponsiveTabs::-webkit-scrollbar {\n  display: none;\n}\n\n.ResponsiveTabs {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  /* Gap fallback for older browsers */\n  margin: 0 -1px;\n  gap: 2px;\n  max-width: 100%;\n  overflow: hidden;\n}\n\n.ResponsiveTabs .nav-item {\n  /* Gap fallback - margin instead of gap for older browsers */\n  margin: 0 1px;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  white-space: nowrap;\n}\n\n/* Large screens - default styling */\n@media (min-width: 1350px) {\n  .ResponsiveTabs {\n    -webkit-flex-wrap: nowrap;\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n  }\n  \n  .tab-link {\n    padding: 4px 10px;\n    font-size: 11px;\n  }\n}\n\n/* Medium screens - reduce padding and allow wrap */\n@media (min-width: 768px) and (max-width: 1349px) {\n  .ResponsiveTabs {\n    -webkit-flex-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    max-width: 100%;\n  }\n  \n  .tab-link {\n    padding: 4px 8px;\n    font-size: 10px;\n  }\n}\n\n/* Mobile devices - single line with scrollbar */\n@media screen and (max-width: 767px) {\n  .ResponsiveTabs {\n    -webkit-flex-wrap: nowrap !important;\n    -ms-flex-wrap: nowrap !important;\n    flex-wrap: nowrap !important;\n    max-width: 100%;\n    overflow-x: auto;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n    /* Firefox scrollbar */\n    scrollbar-width: thin;\n    scrollbar-color: #888 #f1f1f1;\n  }\n\n  /* Webkit browsers (Chrome, Safari, Edge) scrollbar */\n  .ResponsiveTabs::-webkit-scrollbar {\n    height: 6px;\n    display: block;\n    -webkit-appearance: none;\n  }\n\n  .ResponsiveTabs::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    -webkit-border-radius: 3px;\n    border-radius: 3px;\n  }\n\n  .ResponsiveTabs::-webkit-scrollbar-thumb {\n    background: #888;\n    -webkit-border-radius: 3px;\n    border-radius: 3px;\n  }\n\n  .ResponsiveTabs::-webkit-scrollbar-thumb:hover {\n    background: #555;\n  }\n\n  /* Firefox scrollbar fallback */\n  .ResponsiveTabs {\n    scrollbar-width: thin;\n    scrollbar-color: #888 #f1f1f1;\n  }\n\n  .tab-link {\n    padding: 8px;\n    font-size: 8px;\n    white-space: nowrap;\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n  }\n}\n\n\n.marginRight {\n  margin-right: 20px !important;\n}\n\n@media (min-width: 768px) {\n  .main-content-table {\n    margin-left: 240px !important;\n    width: calc(100% - 250px) !important;\n    overflow-y: auto;\n    overflow-x: hidden;\n    height: 100vh;\n  }\n  \n  .main-content-table::-webkit-scrollbar {\n    width: 8px;\n  }\n  \n  .main-content-table::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 4px;\n  }\n  \n  .main-content-table::-webkit-scrollbar-thumb {\n    background: #888;\n    border-radius: 4px;\n  }\n  \n  .main-content-table::-webkit-scrollbar-thumb:hover {\n    background: #555;\n  }\n}\n\n.content-container {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n}\n\n.table-wrapper {\n  margin-bottom: 10px;\n  min-height: 400px;\n  border-radius: 6px;\n  background-color: #fff;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  overflow-x: auto !important;\n  overflow-y: visible !important;\n  width: 100% !important;\n}\n\n.table-container {\n  overflow-y: auto;\n  overflow-x: auto;\n  position: relative;\n  max-height: calc(100vh - 300px);\n}\n\n.table-container::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.table-container::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.table-container::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 4px;\n}\n\n.table-container::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.pagination-container {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.bgColor {\n  background-color: #fafafa;\n}\n\n.dropdown-toggle::after {\n  margin-left: 17px !important;\n}\n\n.marginLeft {\n  margin-left: 14px;\n}\n\n@media (max-width: 799px) {\n  .scroll {\n    width: 500px;\n  }\n}\n\n@media (max-width: 766px) {\n  .scroll {\n    width: 700px;\n  }\n}\n\n@media (max-width: 575px) {\n  .scroll {\n    width: 500px;\n  }\n}\n\n@media (max-width: 500px) {\n  .scroll {\n    width: 400px;\n  }\n}\n\n@media (max-width: 420px) {\n  .scroll {\n    width: 320px;\n  }\n}\n\n@media (max-width: 420px) {\n  .scrollMerchent {\n    width: 380px;\n  }\n}\n\n@media (max-width: 767px) {\n  .main-content-table {\n    margin-left: 0;\n    width: 100%;\n    overflow-y: auto;\n    overflow-x: hidden;\n    height: 100vh;\n  }\n  \n  .main-content-table::-webkit-scrollbar {\n    width: 8px;\n  }\n  \n  .main-content-table::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 4px;\n  }\n  \n  .main-content-table::-webkit-scrollbar-thumb {\n    background: #888;\n    border-radius: 4px;\n  }\n  \n  .main-content-table::-webkit-scrollbar-thumb:hover {\n    background: #555;\n  }\n}\n\n\n\n.text-sm {\n  font-size: 14px;\n}\n\n.negetiveMargin {\n  margin-right: 20px;\n}\n\n.tab-link {\n  color: #000000 !important;\n  font-size: 16px !important;\n  font-weight: 500;\n}\n\n.tab-link.active {\n  color: #019440 !important;\n}\n\n.pagination .page-link {\n  color: #000000;\n  font-size: 8px;\n}\n\n.pagination .page-link:hover {\n  color: #019440;\n  background-color: #ffffff !important;\n  border-color: #27272a !important;\n}\n\n.pagination .page-link:focus {\n  outline: none;\n}\n\n.pagination .page-item.active .page-link {\n  background-color: #019440;\n  border-color: #019440 !important;\n}\n\n.transferbtn:disabled {\n  border: none !important;\n  outline: none !important;\n}\n\n.filter-btn {\n  min-width: 80px;\n  height: 30px;\n  font-weight: 600 !important;\n  box-shadow: -1px 3px 0px rgba(0, 1, 1, 0.2) !important;\n}\n\n.btn-outline-secondary {\n  color: #000 !important;\n  border-color: #ffffff !important;\n  background-color: #ffffff !important;\n  font-size: x-small !important;\n}\n\n.approved-btn {\n  color: #ffffff;\n  border-color: #019440 !important;\n  background-color: #ffffff !important;\n  text-transform: capitalize;\n  font-size: 14px !important;\n  min-width: 80px !important;\n}\n\n.rejectbtn {\n  color: #ffffff !important;\n  font-size: 14px !important;\n  border-color: red !important;\n  background-color: red !important;\n  width: 80px !important;\n}\n\n.btn-outline-secondary:hover {\n  color: #019440 !important;\n  border-color: #019440 !important;\n  background-color: #ffffff !important;\n}\n\n.edit-icon {\n  width: 20px !important;\n}\n\n.btn-outline-secondary:focus {\n  outline: none;\n}\n\n.tableheader-txt {\n  font-size: 11px !important;\n  color: #a1a1aa !important;\n  font-weight: 500 !important;\n  padding: 8px 12px !important;\n}\n\n.tableheader-txt-merchent {\n  font-size: 12px !important;\n  color: #a1a1aa !important;\n  font-weight: 500 !important;\n}\n\n.tabledata-txt {\n  font-size: 11px !important;\n  color: #27272a !important;\n  font-weight: 400 !important;\n  padding: 12px !important;\n  vertical-align: middle !important;\n}\n\n.table-responsive {\n  min-height: 400px !important;\n  overflow-x: auto !important;\n  overflow-y: visible !important;\n  width: 100% !important;\n  margin-left: 0 !important;\n  padding-left: 0 !important;\n  position: relative !important;\n}\n\n.table-responsive::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.table-responsive::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.table-responsive::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 4px;\n}\n\n.table-responsive::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.table-responsive table {\n  min-width: 1000px !important;\n  width: 100% !important;\n  table-layout: auto !important;\n}\n\n.table-responsive table th:nth-child(4),\n.table-responsive table td:nth-child(4) {\n  width: auto !important;\n  min-width: 50px !important;\n  max-width: 70px !important;\n  padding-left: 8px !important;\n  padding-right: 8px !important;\n}\n\n.table-responsive table th:nth-child(5),\n.table-responsive table td:nth-child(5) {\n  width: auto !important;\n  min-width: 60px !important;\n  max-width: 80px !important;\n  padding-left: 8px !important;\n  padding-right: 8px !important;\n}\n\n.table-responsive table th:nth-child(6),\n.table-responsive table td:nth-child(6) {\n  width: auto !important;\n  min-width: 60px !important;\n  max-width: 80px !important;\n  padding-left: 8px !important;\n  padding-right: 8px !important;\n}\n\n.table {\n  margin-bottom: 0 !important;\n}\n\n.table tbody tr {\n  min-height: 50px !important;\n}\n\n@media (min-width: 1280px) {\n  .tableheader-txt {\n    font-size: 12px !important;\n    color: #a1a1aa !important;\n    font-weight: 500 !important;\n    padding: 8px 12px !important;\n    white-space: nowrap !important;\n    overflow: hidden !important;\n    text-overflow: ellipsis !important;\n  }\n  \n  .tabledata-txt {\n    font-size: 12px !important;\n    color: #27272a !important;\n    font-weight: 400 !important;\n    padding: 12px !important;\n    vertical-align: middle !important;\n    white-space: nowrap !important;\n    overflow: hidden !important;\n    text-overflow: ellipsis !important;\n  }\n  \n  .table th {\n    white-space: nowrap !important;\n    overflow: hidden !important;\n    text-overflow: ellipsis !important;\n  }\n  \n  .table th:nth-child(2) {\n    white-space: nowrap !important;\n    overflow: hidden !important;\n    text-overflow: ellipsis !important;\n  }\n  \n  .table th:nth-child(4) {\n    white-space: normal !important;\n    word-wrap: break-word !important;\n    overflow: visible !important;\n    text-overflow: initial !important;\n  }\n  \n  .navbar-nav {\n    flex-wrap: nowrap !important;\n  }\n  \n  .navbar-nav .nav-link {\n    white-space: nowrap !important;\n  }\n  \n  .ResponsiveTabs {\n    -webkit-flex-wrap: nowrap !important;\n    -ms-flex-wrap: nowrap !important;\n    flex-wrap: nowrap !important;\n    white-space: nowrap !important;\n    max-width: 100% !important;\n    overflow: hidden !important;\n  }\n\n  .ResponsiveTabs .nav-item {\n    white-space: nowrap !important;\n  }\n\n  .ResponsiveTabs .nav-link {\n    white-space: nowrap !important;\n    padding: 6px 10px !important;\n    font-size: 12px !important;\n    -webkit-box-sizing: border-box !important;\n    -moz-box-sizing: border-box !important;\n    box-sizing: border-box !important;\n  }\n  \n  .table {\n    table-layout: fixed !important;\n    width: 100% !important;\n  }\n  \n  .table th:nth-child(1) { width: 120px !important; }\n  .table th:nth-child(2) { width: 140px !important; }\n  .table th:nth-child(3) { width: 100px !important; }\n  .table th:nth-child(4) { width: 200px !important; }\n  .table th:nth-child(5) { width: 150px !important; }\n  .table th:nth-child(6) { width: 120px !important; }\n  .table th:nth-child(7) { width: 80px !important; }\n  .table th:nth-child(8) { width: 100px !important; }\n  .table th:nth-child(9) { width: 120px !important; }\n  \n  .table td {\n    white-space: nowrap !important;\n    overflow: hidden !important;\n    text-overflow: ellipsis !important;\n    max-width: 0 !important;\n  }\n  \n  .table td:nth-child(2) {\n    white-space: nowrap !important;\n    overflow: hidden !important;\n    text-overflow: ellipsis !important;\n    max-width: 140px !important;\n    width: 140px !important;\n  }\n  \n  .table td:nth-child(4) {\n    white-space: normal !important;\n    word-wrap: break-word !important;\n    overflow: visible !important;\n    text-overflow: initial !important;\n    max-width: 200px !important;\n    width: 200px !important;\n  }\n  \n  .table td:nth-child(1) { width: 120px !important; max-width: 120px !important; }\n  .table td:nth-child(3) { width: 100px !important; max-width: 100px !important; }\n  .table td:nth-child(5) { width: 150px !important; max-width: 150px !important; }\n  .table td:nth-child(6) { width: 120px !important; max-width: 120px !important; }\n  .table td:nth-child(7) { width: 80px !important; max-width: 80px !important; }\n  .table td:nth-child(8) { width: 100px !important; max-width: 100px !important; }\n  .table td:nth-child(9) { width: 120px !important; max-width: 120px !important; }\n}\n\n.fixed {\n  position: fixed;\n}\n\n.inset-0 {\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.z-50 {\n  z-index: 50;\n}\n\n.bg-black {\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.flex {\n  display: flex;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.justify-center {\n  justify-content: center;\n}\n\n.modal-blur-bg {\n  background-color: rgba(0, 0, 0, 0.3);\n}\n\n.modal-heading-txt {\n  font-size: medium !important;\n  font-weight: 600 !important;\n  color: #000000 !important;\n}\n\n.modal-label-txt {\n  font-size: small !important;\n}\n\n.modal-input-txt {\n  font-size: x-small !important;\n  outline: none !important;\n  box-shadow: none !important;\n  border-color: #a1a1aa !important;\n  border: #ffffff;\n}\n\n.modal-input-txt:hover {\n  border-color: #019440 !important;\n}\n\n.modal-btn-bg {\n  background-color: #019440 !important;\n  color: #ffffff !important;\n}\n\n.modal-header {\n  border-bottom: none !important;\n}\n\n.modal-footer {\n  border-top: none !important;\n}\n\n.notification-modal {\n  margin: 0 !important;\n}\n\n.notification-modalposition {\n  display: block !important;\n  position: fixed !important;\n  top: 8% !important;\n  left: 75% !important;\n  z-index: 1050 !important;\n}\n\n.notification-modal-height {\n  height: 300px !important;\n  width: 300px !important;\n  border: 1px solid #000000 !important;\n}\n\n.separator {\n  border-left: 2px solid #019440;\n  height: 30px;\n  margin: 0 10px;\n}\n\n.balance-box {\n  border: 1px solid #019440;\n  border-radius: 4px;\n  min-width: 180px;\n  justify-content: center;\n  align-items: center;\n  min-height: 70px;\n  height: 70px;\n  display: flex;\n}\n\n.bank-dropdown-wrapper {\n  min-height: 100%;\n}\n\n.bank-select {\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  z-index: 2;\n  cursor: pointer;\n}\n\n.bank-select-display {\n  min-height: 100%;\n  padding: 0;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.balance-txt {\n  font-size: 12px;\n  font-weight: bold;\n  color: #9fa6b2;\n}\n\n.bank-select-option {\n  display: flex;\n  flex-direction: column;\n  font-size: 12px;\n  font-weight: bold;\n  color: #9fa6b2;\n}\n\n.amount-txt {\n  font-size: 16px;\n  color: #019440 !important;\n}\n\n.hgo-text {\n  margin-right: auto;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n}\n\n.textSizeIcon {\n  font-size: 22px;\n}\n\n.dropdown-section {\n  margin-top: 1rem;\n}\n\n.plus-minus-btn {\n  border: none !important;\n  background-color: transparent;\n}\n\n.sidebar {\n  position: fixed;\n  top: 0;\n  left: -250px;\n  width: 240px !important;\n  height: 100%;\n  background: #f3f5f3;\n  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);\n  transition: left 0.3s ease;\n  z-index: 1000;\n  flex-shrink: 0;\n}\n\n.sidebar.open {\n  left: 0;\n}\n\n.main-content.blurred {\n  filter: blur(3px);\n  pointer-events: none;\n}\n\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n  display: none;\n}\n\n.sidebar.open~.overlay {\n  display: block;\n}\n\n.plus-icon {\n  margin-left: auto;\n}\n\n.sidebar-logo-bg {\n  padding: 10px;\n}\n\n.close-btn {\n  background: transparent;\n  border: none;\n  padding-bottom: 18px !important;\n  position: absolute;\n  right: -7px;\n  top: 15px;\n}\n\n.close-btn:hover {\n  cursor: pointer;\n}\n\n.btn-close-notification {\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n@media (min-width: 768px) {\n  .close-btn {\n    display: none;\n  }\n\n  .sidebar {\n    position: fixed;\n    left: 0;\n    width: 210px;\n    height: 100%;\n    background: #f3f5f3;\n    z-index: 1;\n    box-shadow: none;\n  }\n}\n\n.dropdown-toggle::after {\n  border-top: 0.8em solid !important;\n  border-right: 0.4em solid transparent !important;\n  border-left: 0.4em solid transparent !important;\n  vertical-align: middle !important;\n}\n\n.main-content {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.main-content1 {\n  flex-grow: 1 !important;\n  width: 158% !important;\n  margin-left: 20px;\n  padding: 0;\n}\n\n.main-content-incoming {\n  flex-grow: 1 !important;\n  width: 138% !important;\n  margin-left: 20px;\n  padding: 0;\n}\n\n.maincontent-container1 {\n  background-color: #fafafa;\n  height: 94.5vh !important;\n  flex-grow: 1 !important;\n}\n\n.page-link:focus {\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n@media (max-width: 576px) {\n  .bell-icon {\n    margin-left: 0px !important;\n  }\n\n  .main-content {\n    margin-left: 0px !important;\n  }\n\n  .main-content1 {\n    margin-left: 0px;\n    width: 100% !important;\n  }\n\n  .notification-modalposition {\n    display: block !important;\n    position: fixed !important;\n    top: 25% !important;\n    left: 15% !important;\n    z-index: 1050 !important;\n  }\n}\n\n.transferbtn {\n  border-color: none !important;\n  box-shadow: none !important;\n  transition: all 0.3s ease;\n  font-size: 11px !important;\n  padding: 4px 12px !important;\n}\n\n.transferbtn:hover {\n  border-color: #019440 !important;\n  color: #019440 !important;\n}\n\n.transferbtn.active {\n  background-color: #019440;\n}\n\n.btn-compact {\n  padding: 0.1rem 0.1rem !important;\n  color: #ffffff;\n  border-color: #019440 !important;\n  background-color: #ffffff !important;\n  font-size: xx-small !important;\n  width: 45px !important;\n  margin-bottom: 3px;\n}\n\n.btn-compactreject {\n  padding: 0.1rem 0.1rem !important;\n  color: #ffffff !important;\n  border-color: red !important;\n  background-color: red !important;\n  font-size: xx-small !important;\n  width: 45px !important;\n  margin-bottom: 3px;\n}\n\n.add-button {\n  background-color: #cffce1;\n  width: 60px;\n  height: 40px;\n  border-radius: 5px;\n  padding: 10px;\n  border: none !important;\n}\n\n.greenplusbtn {\n  color: #019440 !important;\n  font-size: 20px !important;\n}\n\n.bgWhite {\n  background-color: #fff;\n  padding: 10px;\n  margin-top: -23px;\n  margin-left: -23px;\n  padding-left: 40px;\n}\n\n.container {\n  margin: 20px auto;\n  padding: 20px;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  max-height: 100vh;\n  overflow-y: auto;\n  overflow-x: none;\n}\n\n.myContainer {\n  overflow-x: hidden;\n  padding: 10px;\n}\n\n.rola {\n  width: 100%;\n  display: flex;\n  justify-content: end;\n}\n\nh2 {\n  color: #333;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n}\n\n.row {\n  display: flex;\n  margin-bottom: 15px;\n}\n\n.heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-left: 10px;\n  padding-right: 10px;\n  margin-top: 20px;\n}\n\n.column {\n  flex: 0 0 33.33%;\n  display: flex;\n  flex-direction: column;\n}\n\nselect {\n  font-size: 14px !important;\n  width: 30px;\n}\n\n.margin {\n  margin-right: 100px;\n}\n\nlabel {\n  margin-bottom: 5px;\n  color: #555;\n}\n\ninput,\nselect {\n  padding: 10px;\n  font-size: 14px;\n  border: 1px solid #ccc;\n  border-radius: 10px;\n  width: 100%;\n}\n\n.date input {\n  text-align: center;\n  background-color: #e9ecef;\n  border: none;\n  width: 100px;\n  font-size: 12px;\n}\n\n.submit-btn {\n  background-color: #019440;\n  color: white;\n  padding: 10px;\n  font-size: 16px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  margin-top: 10px;\n}\n\n.add-btn {\n  color: #28a745;\n  background: #FAFAFA;\n  padding: 10px;\n  font-size: 16px;\n  border: none;\n  cursor: pointer;\n  margin-top: 10px;\n  font-weight: bold;\n}\n\n.add-btn {\n  width: 100px;\n  align-self: flex-start;\n}\n\n.submit-btn {\n  width: 30%;\n  align-self: center;\n}\n\n.submit-btn:hover {\n  background-color: #218838;\n}\n\n.textSize {\n  font-size: 116px !important;\n}\n\n@media (max-width: 768px) {\n  .row {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 768px) {\n  .rola {\n    justify-content: center;\n  }\n}\n\n@media (max-width: 768px) {\n  .myContainer {\n    height: 60vh;\n    overflow-y: scroll;\n  }\n}\n\n@media (max-width: 760px) {\n  .myContainer {\n    height: 55vh;\n    overflow-y: scroll;\n  }\n}\n\n\n.conversion {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.btn-approved {\n  background-color: #28a745 !important;\n  color: white !important;\n  border: none !important;\n  border-radius: 4px !important;\n  padding: 4px 12px !important;\n  font-size: 12px !important;\n}\n\n.btn-reject {\n  background-color: #dc3545 !important;\n  color: white !important;\n  border: none !important;\n  border-radius: 4px !important;\n  padding: 4px 12px !important;\n  font-size: 12px !important;\n}\n\n.btn-pending {\n  background-color: #ffc107 !important;\n  color: white !important;\n  border: none !important;\n  border-radius: 4px !important;\n  padding: 4px 12px !important;\n  font-size: 12px !important;\n}\n\n.loading-container {\n  min-height: 200px;\n}\n\n.spinner-green {\n  color: #198754;\n}\n\n.user-name-text {\n  font-size: 12px;\n}\n\n.edit-icon-green {\n  color: #198754;\n  margin-left: 7px;\n  cursor: pointer;\n}\n\n.loading-container-ehajj {\n  min-height: 200px;\n}\n\n.user-transaction-table .col-date,\n.main-transaction-table .col-date {\n  width: 15%;\n}\n\n.user-transaction-table .col-narration,\n.main-transaction-table .col-narration {\n  width: 40%;\n}\n\n.user-transaction-table .col-debit,\n.main-transaction-table .col-debit {\n  width: 15%;\n}\n\n.user-transaction-table .col-credit,\n.main-transaction-table .col-credit {\n  width: 15%;\n}\n\n.user-transaction-table .col-balance,\n.main-transaction-table .col-balance {\n  width: 15%;\n}\n\n.monazam-account-table .monazam-narration-col {\n  min-width: 320px !important;\n  max-width: none !important;\n}\n\n.monazam-account-table .monazam-bank-name-col {\n  min-width: 220px !important;\n  max-width: none !important;\n}\n\n.monazam-account-table .monazam-debit-col {\n  min-width: 55px !important;\n  max-width: 75px !important;\n  padding: 6px !important;\n}\n\n.monazam-account-table .monazam-credit-col {\n  min-width: 55px !important;\n  max-width: 75px !important;\n  padding: 6px !important;\n}\n\n.monazam-account-table .monazam-balance-col {\n  min-width: 65px !important;\n  max-width: 85px !important;\n  padding: 6px !important;\n}\n\n.bank-dropdown-custom {\n  height: 70px !important;\n  min-height: 70px !important;\n}\n\n.bank-dropdown-selected {\n  height: 100% !important;\n  min-height: 100% !important;\n}\n\n.filter-button {\n  color: black;\n  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.15);\n  font-size: 14px;\n}\n\n.conversion input {\n  width: 45%;\n  padding: 5px;\n  margin: 0 5px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\nbutton {\n  font-size: 12px;\n  padding: 10px 15px;\n  margin: 5px;\n  border: none;\n  background: #007bff;\n  color: #fff;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\nbutton:disabled {\n  background: #ccc;\n}\n\n.download-btn {\n  background-color: transparent;\n  border: none;\n  padding: 5px;\n  cursor: pointer;\n}\n\n.download-icon {\n  color: #333;\n  font-size: 16px;\n}\n\n.small-text {\n  font-size: 12px;\n}\n\n.edit-icon-green {\n  color: #198754;\n  margin-left: 7px;\n  cursor: pointer;\n}\n\n.loading-container {\n  min-height: 200px;\n}\n\n.spinner-green {\n  color: #198754;\n}\n\n.user-name-text {\n  font-size: 12px;\n}\n\n.edit-icon-green {\n  color: #198754;\n  margin-left: 7px;\n  cursor: pointer;\n}\n\n.loading-container-ehajj {\n  min-height: 200px;\n}\n\n.user-transaction-table .col-date,\n.main-transaction-table .col-date {\n  width: 15%;\n}\n\n.user-transaction-table .col-narration,\n.main-transaction-table .col-narration {\n  width: 40%;\n}\n\n.user-transaction-table .col-debit,\n.main-transaction-table .col-debit {\n  width: 15%;\n}\n\n.user-transaction-table .col-credit,\n.main-transaction-table .col-credit {\n  width: 15%;\n}\n\n.user-transaction-table .col-balance,\n.main-transaction-table .col-balance {\n  width: 15%;\n}\n\n.monazam-account-table .monazam-narration-col {\n  min-width: 320px !important;\n  max-width: none !important;\n}\n\n.monazam-account-table .monazam-bank-name-col {\n  min-width: 220px !important;\n  max-width: none !important;\n}\n\n.monazam-account-table .monazam-debit-col {\n  min-width: 55px !important;\n  max-width: 75px !important;\n  padding: 6px !important;\n}\n\n.monazam-account-table .monazam-credit-col {\n  min-width: 55px !important;\n  max-width: 75px !important;\n  padding: 6px !important;\n}\n\n.monazam-account-table .monazam-balance-col {\n  min-width: 65px !important;\n  max-width: 85px !important;\n  padding: 6px !important;\n}\n\n.bank-dropdown-custom {\n  height: 70px !important;\n  min-height: 70px !important;\n}\n\n.bank-dropdown-selected {\n  height: 100% !important;\n  min-height: 100% !important;\n}\n\n.file-upload-area {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 1rem;\n}\n\n.file-input {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.file-upload-label {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1rem;\n  background-color: #f8f9fa;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  font-size: 14px;\n  color: #495057;\n  width: 100%;\n  min-width: unset;\n}\n\n.file-upload-label:hover {\n  background-color: #e9ecef;\n}\n\n.upload-icon {\n  font-size: 16px;\n}\n\n.small-text {\n  font-size: 12px;\n}\n\n.edit-icon-green {\n  color: #198754;\n  margin-left: 7px;\n  cursor: pointer;\n}\n\n.loading-container {\n  min-height: 200px;\n}\n\n.spinner-green {\n  color: #198754;\n}\n\n.user-name-text {\n  font-size: 12px;\n}\n\n.edit-icon-green {\n  color: #198754;\n  margin-left: 7px;\n  cursor: pointer;\n}\n\n.loading-container-ehajj {\n  min-height: 200px;\n}\n\n.user-transaction-table .col-date,\n.main-transaction-table .col-date {\n  width: 15%;\n}\n\n.user-transaction-table .col-narration,\n.main-transaction-table .col-narration {\n  width: 40%;\n}\n\n.user-transaction-table .col-debit,\n.main-transaction-table .col-debit {\n  width: 15%;\n}\n\n.user-transaction-table .col-credit,\n.main-transaction-table .col-credit {\n  width: 15%;\n}\n\n.user-transaction-table .col-balance,\n.main-transaction-table .col-balance {\n  width: 15%;\n}\n\n.monazam-account-table .monazam-narration-col {\n  min-width: 320px !important;\n  max-width: none !important;\n}\n\n.monazam-account-table .monazam-bank-name-col {\n  min-width: 220px !important;\n  max-width: none !important;\n}\n\n.monazam-account-table .monazam-debit-col {\n  min-width: 55px !important;\n  max-width: 75px !important;\n  padding: 6px !important;\n}\n\n.monazam-account-table .monazam-credit-col {\n  min-width: 55px !important;\n  max-width: 75px !important;\n  padding: 6px !important;\n}\n\n.monazam-account-table .monazam-balance-col {\n  min-width: 65px !important;\n  max-width: 85px !important;\n  padding: 6px !important;\n}\n\n.bank-dropdown-custom {\n  height: 70px !important;\n  min-height: 70px !important;\n}\n\n.bank-dropdown-selected {\n  height: 100% !important;\n  min-height: 100% !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
